export const movies = [
  {
    id: "m1",
    title: "星际迷航：黎明",
    subtitle: "当群星熄灭，人类最后一次启航",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "欧美",
    year: 2024,
    duration: "138分钟",
    rating: 8.6,
    director: "陈思远",
    cast: ["林寒", "苏晚", "周野"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20planet%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20dramatic%20rim%20light%2C%20minimal%20geometric%20composition%2C%20epic%20futuristic%20mood%2C%20high%20detail&width=400&height=600&seq=m1-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20sci-fi%20scene%2C%20vast%20starfield%20with%20a%20colossal%20ringed%20planet%2C%20deep%20navy%20blue%20space%20with%20warm%20orange%20nebula%20glow%2C%20subtle%20spaceship%20silhouette%2C%20atmospheric%20light%20rays%2C%20dramatic%20and%20elegant%2C%20high%20detail%20digital%20art&width=1600&height=800&seq=m1-banner-91aa&orientation=landscape",
    summary:
      "在恒星能源枯竭的末世纪元，一支由科学家与老兵组成的探索小队踏上了寻找第二家园的旅程。漫长航程中，他们必须面对孤独、猜忌与来自深空的未知回应。",
    updatedAt: "2026-10-14",
    hot: 9820,
    episodes: [],
  },
  {
    id: "m2",
    title: "暗夜追凶",
    subtitle: "真相藏在每一滴雨里",
    type: "movie",
    genres: ["悬疑", "犯罪"],
    region: "大陆",
    year: 2023,
    duration: "122分钟",
    rating: 8.1,
    director: "赵启明",
    cast: ["韩沉", "白栀子", "程骁"],
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%2C%20rain%20slicked%20city%20alley%20at%20night%2C%20lone%20figure%20in%20long%20coat%20under%20a%20street%20lamp%2C%20teal%20and%20amber%20contrast%20lighting%2C%20heavy%20atmosphere%2C%20film%20noir%20composition%2C%20gritty%20and%20cinematic&width=400&height=600&seq=m2-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Rainy%20noir%20city%20street%20at%20night%2C%20wet%20asphalt%20reflecting%20amber%20lamps%2C%20distant%20silhouette%20walking%20away%2C%20deep%20teal%20shadows%20and%20warm%20highlights%2C%20mysterious%20cinematic%20mood%2C%20high%20detail%20photography&width=1600&height=800&seq=m2-banner-91aa&orientation=landscape",
    summary:
      "一桩沉寂十年的悬案因一段残缺录音重新翻开。退休刑警与年轻法医在连绵的雨夜里追查线索，却发现真相比想象中更接近自己的过去。",
    updatedAt: "2026-10-12",
    hot: 8640,
    episodes: [],
  },
  {
    id: "m3",
    title: "山海之恋",
    subtitle: "跨越千年的重逢",
    type: "movie",
    genres: ["爱情", "奇幻"],
    region: "大陆",
    year: 2024,
    duration: "116分钟",
    rating: 7.8,
    director: "苏念安",
    cast: ["温以宁", "顾清尘", "陆昀"],
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%2C%20misty%20ancient%20mountain%20range%20with%20glowing%20lanterns%2C%20two%20silhouettes%20facing%20across%20a%20sea%20of%20clouds%2C%20soft%20rose%20and%20warm%20amber%20palette%2C%20ethereal%20dreamy%20atmosphere%2C%20elegant%20composition%2C%20high%20detail&width=400&height=600&seq=m3-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Ethereal%20ancient%20Chinese%20landscape%2C%20layered%20misty%20mountains%20at%20dusk%2C%20floating%20paper%20lanterns%20glowing%20warm%20orange%2C%20soft%20rose%20and%20indigo%20sky%2C%20dreamy%20romantic%20fantasy%20mood%2C%20high%20detail%20cinematic%20art&width=1600&height=800&seq=m3-banner-91aa&orientation=landscape",
    summary:
      "修复古籍的少女在一幅残卷中遇见了千年前的守山人。跨越时间的书信往来让两人产生羁绊，而每寄出一封信，记忆便随之消散。",
    updatedAt: "2026-10-11",
    hot: 7210,
    episodes: [],
  },
  {
    id: "m4",
    title: "城市之光",
    subtitle: "每个平凡的人都在发光",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "大陆",
    year: 2022,
    duration: "129分钟",
    rating: 8.9,
    director: "沈牧之",
    cast: ["顾青禾", "杨正", "徐来"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20movie%20poster%2C%20quiet%20city%20crosswalk%20at%20blue%20hour%2C%20silhouette%20of%20a%20parent%20and%20child%20holding%20hands%2C%20soft%20amber%20window%20lights%2C%20gentle%20hopeful%20tone%2C%20simple%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=m4-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Warm%20city%20skyline%20at%20blue%20hour%2C%20thousands%20of%20soft%20amber%20window%20lights%2C%20calm%20hopeful%20mood%2C%20gentle%20gradient%20from%20indigo%20to%20gold%2C%20clean%20cinematic%20photography%2C%20high%20detail&width=1600&height=800&seq=m4-banner-91aa&orientation=landscape",
    summary:
      "外卖骑手、便利店店员与退休教师，三条看似无关的生活轨迹在一场突如其来的停电夜交汇。他们用各自微弱的光，照亮了彼此的路。",
    updatedAt: "2026-10-09",
    hot: 9130,
    episodes: [],
  },
  {
    id: "m5",
    title: "荒野行动",
    subtitle: "没有退路，只能向前",
    type: "movie",
    genres: ["动作", "冒险"],
    region: "欧美",
    year: 2024,
    duration: "145分钟",
    rating: 7.5,
    director: "Marcus Vale",
    cast: ["David Kray", "Lena Ford", "Owen Reyes"],
    cover:
      "https://readdy.ai/api/search-image?query=Intense%20action%20adventure%20movie%20poster%2C%20rugged%20desert%20canyon%20with%20dust%20and%20heat%20haze%2C%20lone%20traveler%20with%20backpack%20silhouette%2C%20burnt%20orange%20and%20deep%20brown%20palette%2C%20dramatic%20contrast%20light%2C%20gritty%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=m5-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Vast%20dramatic%20desert%20canyon%20at%20sunset%2C%20dust%20swirling%20in%20warm%20orange%20light%2C%20tiny%20lone%20figure%20crossing%20the%20frame%2C%20epic%20scale%2C%20gritty%20adventure%20cinematography%2C%20high%20detail&width=1600&height=800&seq=m5-banner-91aa&orientation=landscape",
    summary:
      "一支地质勘探队在无人区失联，经验丰富的向导带领小队穿越沙暴与断崖展开搜救。当补给耗尽，他们必须在信任与生存之间做出选择。",
    updatedAt: "2026-10-08",
    hot: 6480,
    episodes: [],
  },
  {
    id: "m6",
    title: "时光信箱",
    subtitle: "写给过去的每一封信，都有回音",
    type: "movie",
    genres: ["科幻", "爱情"],
    region: "日韩",
    year: 2023,
    duration: "110分钟",
    rating: 8.3,
    director: "高濑凉介",
    cast: ["佐藤凛", "井上遥", "木村昴"],
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20sci-fi%20romance%20movie%20poster%2C%20old%20wooden%20mailbox%20in%20a%20snowy%20suburban%20street%2C%20soft%20warm%20lamp%20glow%2C%20cool%20blue%20snow%20and%20amber%20contrast%2C%20gentle%20nostalgic%20mood%2C%20minimal%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=m6-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Serene%20snowy%20residential%20street%20at%20dusk%2C%20warm%20amber%20window%20lights%2C%20soft%20falling%20snow%2C%20cool%20blue%20tones%20with%20warm%20accents%2C%20calm%20nostalgic%20winter%20mood%2C%20high%20detail%20photography&width=1600&height=800&seq=m6-banner-91aa&orientation=landscape",
    summary:
      "一台能向过去投递信件的旧信箱，让失去母亲的青年得以与十年前的自己通信。他试图改写遗憾，却发现每一次修改都要付出代价。",
    updatedAt: "2026-10-06",
    hot: 7890,
    episodes: [],
  },
  {
    id: "m7",
    title: "深海救援",
    subtitle: "下潜三千米，只为一个承诺",
    type: "movie",
    genres: ["灾难", "动作"],
    region: "欧美",
    year: 2025,
    duration: "132分钟",
    rating: 7.9,
    director: "Marcus Vale",
    cast: ["Lena Ford", "Chris Nolan", "Pia Gomez"],
    cover:
      "https://readdy.ai/api/search-image?query=Disaster%20thriller%20movie%20poster%2C%20deep%20sea%20submersible%20lit%20by%20a%20narrow%20beam%2C%20dark%20abyssal%20blue%20water%2C%20single%20warm%20amber%20light%20source%2C%20tense%20claustrophobic%20mood%2C%20dramatic%20contrast%2C%20cinematic%20high%20detail&width=400&height=600&seq=m7-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Deep%20ocean%20abyss%20scene%2C%20distant%20submersible%20with%20a%20single%20warm%20light%20beam%2C%20dark%20navy%20blue%20water%20with%20faint%20particles%2C%20tense%20atmospheric%20mood%2C%20epic%20scale%2C%20high%20detail%20cinematic%20art&width=1600&height=800&seq=m7-banner-91aa&orientation=landscape",
    summary:
      "深海钻探平台突发事故，数十名工人被困三千米海底。一支临时组建的救援小队在有限氧气与不断塌陷的舱体中，与时间展开赛跑。",
    updatedAt: "2026-10-15",
    hot: 8760,
    episodes: [],
  },
  {
    id: "m8",
    title: "无声告白",
    subtitle: "有些话，要用一生来说",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "大陆",
    year: 2023,
    duration: "105分钟",
    rating: 8.4,
    director: "沈牧之",
    cast: ["顾青禾", "林寒", "周野"],
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20family%20drama%20movie%20poster%2C%20elderly%20hands%20holding%20a%20faded%20photograph%20by%20a%20window%2C%20soft%20warm%20daylight%2C%20muted%20beige%20and%20warm%20gray%20palette%2C%20tender%20melancholic%20mood%2C%20simple%20touching%20composition%2C%20high%20detail&width=400&height=600&seq=m8-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Sunlit%20old%20family%20home%20interior%2C%20dust%20motes%20in%20warm%20afternoon%20light%2C%20faded%20photographs%20on%20a%20wooden%20table%2C%20muted%20beige%20tones%2C%20tender%20nostalgic%20mood%2C%20high%20detail%20photography&width=1600&height=800&seq=m8-banner-91aa&orientation=landscape",
    summary:
      "一位沉默寡言的父亲与多年未归的女儿，在一场葬礼后被迫共处一室。那些从未说出口的歉意与牵挂，在旧物与日常里慢慢浮现。",
    updatedAt: "2026-10-05",
    hot: 6900,
    episodes: [],
  },
  {
    id: "m9",
    title: "极速飞车",
    subtitle: "极限之上，只有对手和自己",
    type: "movie",
    genres: ["动作", "赛车"],
    region: "欧美",
    year: 2025,
    duration: "118分钟",
    rating: 7.2,
    director: "Diego Sartre",
    cast: ["Owen Reyes", "Nina Blake", "Karl Voss"],
    cover:
      "https://readdy.ai/api/search-image?query=High%20octane%20racing%20movie%20poster%2C%20sleek%20sports%20car%20drifting%20on%20wet%20night%20circuit%2C%20streaking%20amber%20and%20white%20light%20trails%2C%20deep%20navy%20blue%20background%2C%20dynamic%20motion%20blur%2C%20bold%20cinematic%20energy%2C%20high%20detail&width=400&height=600&seq=m9-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Night%20city%20highway%20race%20scene%2C%20blurred%20amber%20and%20white%20light%20trails%2C%20wet%20road%20reflections%2C%20deep%20navy%20sky%2C%20high%20speed%20motion%20energy%2C%20cinematic%20high%20detail&width=1600&height=800&seq=m9-banner-91aa&orientation=landscape",
    summary:
      "退役车手为偿还弟弟的债务重返地下赛道，面对的是昔日队友与一台几乎不可能战胜的原型车。速度之外，他要赢回的是尊严。",
    updatedAt: "2026-10-13",
    hot: 5980,
    episodes: [],
  },
  {
    id: "t1",
    title: "长安风云录",
    subtitle: "一城风雨，半部盛唐",
    type: "tv",
    genres: ["古装", "历史"],
    region: "大陆",
    year: 2024,
    duration: "全40集",
    rating: 9.0,
    director: "裴长风",
    cast: ["顾清尘", "温以宁", "韩沉"],
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20Chinese%20drama%20poster%2C%20grand%20ancient%20capital%20city%20at%20dusk%2C%20red%20lanterns%20and%20golden%20roofs%2C%20lone%20official%20silhouette%20before%20a%20palace%20gate%2C%20deep%20crimson%20and%20amber%20palette%2C%20majestic%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=t1-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Panoramic%20ancient%20Chinese%20imperial%20palace%20at%20dusk%2C%20layered%20rooftops%20and%20red%20lanterns%2C%20warm%20amber%20and%20deep%20crimson%20sky%2C%20golden%20light%20on%20eaves%2C%20majestic%20historical%20atmosphere%2C%20high%20detail&width=1600&height=800&seq=t1-banner-91aa&orientation=landscape",
    summary:
      "安史之乱前后的长安城，一名出身寒微的小吏在朝堂与市井之间周旋。他以微薄之力守护一城百姓，也见证了一个时代的兴衰。",
    updatedAt: "2026-10-14",
    hot: 9950,
    episodes: [
      { id: "t1-1", title: "第1集 · 入城", desc: "寒门书生初入长安，一场突如其来的骚乱改变了他的命运。" },
      { id: "t1-2", title: "第2集 · 案牍", desc: "在户部当差的第一天，他发现账目里藏着惊人的秘密。" },
      { id: "t1-3", title: "第3集 · 夜宴", desc: "权贵夜宴之上，一句无心之言引来杀身之祸。" },
      { id: "t1-4", title: "第4集 · 密信", desc: "一封匿名密信送到案前，指向十年前的一桩旧案。" },
      { id: "t1-5", title: "第5集 · 抉择", desc: "在恩人与真相之间，他必须做出第一次真正的选择。" },
      { id: "t1-6", title: "第6集 · 风起", desc: "边关告急的消息传来，长安城的平静被彻底打破。" },
    ],
  },
  {
    id: "t2",
    title: "都市浮生",
    subtitle: "在钢筋森林里寻找自己",
    type: "tv",
    genres: ["都市", "情感"],
    region: "大陆",
    year: 2024,
    duration: "全36集",
    rating: 8.2,
    director: "文悠然",
    cast: ["苏晚", "陆昀", "徐来"],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%2C%20young%20professional%20standing%20on%20a%20glass%20office%20balcony%20overlooking%20a%20night%20city%2C%20cool%20navy%20blue%20and%20warm%20amber%20window%20lights%2C%20reflective%20melancholic%20mood%2C%20clean%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=t2-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20night%20seen%20through%20a%20rainy%20office%20window%2C%20warm%20amber%20interior%20reflection%2C%20cool%20navy%20blue%20outside%2C%20contemplative%20urban%20mood%2C%20high%20detail%20photography&width=1600&height=800&seq=t2-banner-91aa&orientation=landscape",
    summary:
      "三位合租的年轻人在同一栋写字楼里奔波。升职、失恋、房东涨价，生活的难题接踵而至，而他们学会了在彼此身上找到继续的理由。",
    updatedAt: "2026-10-12",
    hot: 8340,
    episodes: [
      { id: "t2-1", title: "第1集 · 合租", desc: "三个陌生人在中介的催促下签下了同一份租约。" },
      { id: "t2-2", title: "第2集 · 早高峰", desc: "地铁里的一次让座，让两个本无交集的人开始对话。" },
      { id: "t2-3", title: "第3集 · 提案", desc: "熬夜做出的方案在会议上被否定，她第一次想要放弃。" },
      { id: "t2-4", title: "第4集 · 迟到的电话", desc: "母亲深夜的来电，藏着一个迟迟未说的消息。" },
      { id: "t2-5", title: "第5集 · 搬家", desc: "房租涨价的通知贴上门来，生活再次被推着向前。" },
      { id: "t2-6", title: "第6集 · 天台", desc: "四个人在天台喝酒，聊起那些没能实现的梦想。" },
    ],
  },
  {
    id: "t3",
    title: "破案先锋",
    subtitle: "每一个细节都不会说谎",
    type: "tv",
    genres: ["刑侦", "悬疑"],
    region: "大陆",
    year: 2023,
    duration: "全32集",
    rating: 8.7,
    director: "赵启明",
    cast: ["韩沉", "白栀子", "程骁"],
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20investigation%20drama%20poster%2C%20dim%20evidence%20room%20with%20case%20files%20and%20a%20single%20desk%20lamp%2C%20deep%20teal%20shadows%20and%20amber%20pool%20of%20light%2C%20lone%20detective%20silhouette%2C%20tense%20moody%20atmosphere%2C%20high%20detail&width=400&height=600&seq=t3-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Moody%20police%20evidence%20board%20covered%20in%20photographs%20and%20red%20string%2C%20dim%20teal%20lighting%20with%20a%20warm%20amber%20lamp%2C%20tense%20investigation%20atmosphere%2C%20cinematic%20high%20detail&width=1600&height=800&seq=t3-banner-91aa&orientation=landscape",
    summary:
      "市局重案组迎来一名不按常理出牌的新队长。他用近乎偏执的观察力串联起几起看似无关的案件，也揭开了一支隐藏在暗处的作案链条。",
    updatedAt: "2026-10-10",
    hot: 9120,
    episodes: [
      { id: "t3-1", title: "第1集 · 报案", desc: "一起普通的失踪报案，现场却少了最重要的那件物品。" },
      { id: "t3-2", title: "第2集 · 时间线", desc: "重案组用一张白板梳理出矛盾的目击证词。" },
      { id: "t3-3", title: "第3集 · 旧案", desc: "新发现的物证，指向了五年前封存的档案。" },
      { id: "t3-4", title: "第4集 · 卧底", desc: "为了接近目标，一名队员走上了危险的边缘。" },
      { id: "t3-5", title: "第5集 · 反转", desc: "最信任的证人突然改口，案情急转直下。" },
      { id: "t3-6", title: "第6集 · 收网", desc: "所有线索在同一天汇聚，真相即将浮出水面。" },
    ],
  },
  {
    id: "t4",
    title: "山海食堂",
    subtitle: "一碗热汤，治愈所有疲惫",
    type: "tv",
    genres: ["治愈", "美食"],
    region: "日韩",
    year: 2024,
    duration: "全24集",
    rating: 8.5,
    director: "高濑凉介",
    cast: ["佐藤凛", "井上遥", "小林和"],
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20healing%20food%20drama%20poster%2C%20small%20warm%20street%20eatery%20at%20night%2C%20glowing%20paper%20lanterns%20and%20steaming%20bowls%2C%20soft%20amber%20and%20warm%20brown%20palette%2C%20inviting%20tender%20mood%2C%20gentle%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=t4-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20street%20food%20alley%20at%20dusk%2C%20rows%20of%20glowing%20paper%20lanterns%2C%20steam%20rising%20from%20stalls%2C%20soft%20amber%20and%20warm%20brown%20tones%2C%20inviting%20comforting%20atmosphere%2C%20high%20detail%20photography&width=1600&height=800&seq=t4-banner-91aa&orientation=landscape",
    summary:
      "海边小城的一间深夜食堂，老板只做当天能买到的食材。每一位深夜到访的客人都带着自己的故事，而一碗热汤之后，他们重新出发。",
    updatedAt: "2026-10-09",
    hot: 7560,
    episodes: [
      { id: "t4-1", title: "第1集 · 开张", desc: "深夜营业的小店迎来第一位客人，一位沉默的船员。" },
      { id: "t4-2", title: "第2集 · 味增汤", desc: "一碗家常味增汤，让离家多年的女孩想起了母亲。" },
      { id: "t4-3", title: "第3集 · 打烊前", desc: "最后十分钟到店的客人，只想点一份最简单的饭。" },
      { id: "t4-4", title: "第4集 · 雨天", desc: "大雨夜里，两个陌生人因一张小桌而相识。" },
      { id: "t4-5", title: "第5集 · 老味道", desc: "老板尝试复原一道早已失传的家乡菜。" },
      { id: "t4-6", title: "第6集 · 常客", desc: "每天都来的那位客人，今天终于说出了心事。" },
    ],
  },
  {
    id: "t5",
    title: "未来纪元",
    subtitle: "当记忆可以被上传",
    type: "tv",
    genres: ["科幻", "悬疑"],
    region: "欧美",
    year: 2025,
    duration: "全20集",
    rating: 8.8,
    director: "Nadia Frost",
    cast: ["Pia Gomez", "Chris Nolan", "Nina Blake"],
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20series%20poster%2C%20glowing%20circuit%20brain%20cradled%20in%20two%20hands%2C%20deep%20navy%20blue%20with%20electric%20orange%20lines%2C%20minimal%20high%20tech%20composition%2C%20clean%20and%20premium%20mood%2C%20high%20detail%20digital%20art&width=400&height=600&seq=t5-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Futuristic%20data%20center%20with%20rows%20of%20glowing%20servers%2C%20deep%20navy%20blue%20darkness%20with%20electric%20orange%20light%20lines%2C%20cold%20clean%20high%20tech%20atmosphere%2C%20high%20detail%20cinematic&width=1600&height=800&seq=t5-banner-91aa&orientation=landscape",
    summary:
      "在不远的未来，人类可以将记忆上传云端。当一批被删改的记忆意外流入黑市，一名数据调查员必须分辨：哪些是真相，哪些是被人精心编写的过去。",
    updatedAt: "2026-10-13",
    hot: 9480,
    episodes: [
      { id: "t5-1", title: "第1集 · 上传", desc: "一次常规的记忆备份，出现了一段不属于任何人的画面。" },
      { id: "t5-2", title: "第2集 · 幽灵数据", desc: "调查员在被删除的档案中发现一个反复出现的名字。" },
      { id: "t5-3", title: "第3集 · 记忆黑市", desc: "为了追查源头，她不得不走进最危险的交易市场。" },
      { id: "t5-4", title: "第4集 · 副本", desc: "一段被复制三次的记忆，指向了三个不同的人。" },
      { id: "t5-5", title: "第5集 · 围墙", desc: "系统开始自我修正，真相被一层层封存。" },
      { id: "t5-6", title: "第6集 · 抉择", desc: "她必须在保留证据和保住自己之间做出选择。" },
    ],
  },
  {
    id: "t6",
    title: "宫墙柳",
    subtitle: "深宫之中，无人无辜",
    type: "tv",
    genres: ["古装", "权谋"],
    region: "大陆",
    year: 2024,
    duration: "全45集",
    rating: 7.9,
    director: "裴长风",
    cast: ["温以宁", "白栀子", "苏念安"],
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20palace%20drama%20poster%2C%20lone%20lady%20in%20traditional%20gown%20before%20a%20red%20palace%20wall%20and%20weeping%20willow%2C%20muted%20crimson%20and%20soft%20gold%20palette%2C%20melancholic%20refined%20mood%2C%20high%20detail&width=400&height=600&seq=t6-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20a%20weeping%20willow%20and%20red%20walls%2C%20soft%20misty%20morning%20light%2C%20muted%20crimson%20and%20gold%20tones%2C%20quiet%20melancholic%20atmosphere%2C%20high%20detail&width=1600&height=800&seq=t6-banner-91aa&orientation=landscape",
    summary:
      "出身书香门第的女子入宫为女官，本只想安稳度日。然而后宫与前朝暗流交织，她被迫卷入一场关乎家族存亡的权谋博弈。",
    updatedAt: "2026-10-08",
    hot: 8120,
    episodes: [
      { id: "t6-1", title: "第1集 · 入宫", desc: "一顶小轿抬入宫门，她的名字从此被写进名册。" },
      { id: "t6-2", title: "第2集 · 规矩", desc: "宫中的第一课，是学会什么话不能说。" },
      { id: "t6-3", title: "第3集 · 旧识", desc: "一位故人的出现，让她想起了入宫前的心愿。" },
      { id: "t6-4", title: "第4集 · 赏花", desc: "一场看似寻常的赏花宴，暗藏着一个陷阱。" },
      { id: "t6-5", title: "第5集 · 密约", desc: "深夜里的一次秘密会见，改变了两方势力的平衡。" },
      { id: "t6-6", title: "第6集 · 风波", desc: "一封被截获的家书，让她与家族陷入险境。" },
    ],
  },
  {
    id: "t7",
    title: "青春纪事",
    subtitle: "那年夏天，我们都没说再见",
    type: "tv",
    genres: ["校园", "青春"],
    region: "大陆",
    year: 2023,
    duration: "全28集",
    rating: 7.6,
    director: "文悠然",
    cast: ["徐来", "林小满", "周野"],
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20coming%20of%20age%20drama%20poster%2C%20two%20students%20sitting%20on%20a%20school%20rooftop%20at%20sunset%2C%20warm%20golden%20light%20and%20soft%20blue%20sky%2C%20gentle%20youthful%20bittersweet%20mood%2C%20clean%20minimal%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=t7-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=School%20sports%20field%20and%20classroom%20building%20at%20golden%20sunset%2C%20warm%20orange%20light%20and%20soft%20blue%20sky%2C%20long%20shadows%2C%20nostalgic%20youthful%20summer%20mood%2C%20high%20detail%20photography&width=1600&height=800&seq=t7-banner-91aa&orientation=landscape",
    summary:
      "六个性格迥异的高中生在同一个班级度过三年。他们一起经历考试、暗恋、告别与重逢，而青春的答案，往往要在很多年以后才明白。",
    updatedAt: "2026-10-04",
    hot: 6320,
    episodes: [
      { id: "t7-1", title: "第1集 · 开学", desc: "新学期第一天，座位表把六个人分在了一起。" },
      { id: "t7-2", title: "第2集 · 晚自习", desc: "停电的晚自习，教室里第一次响起了合唱。" },
      { id: "t7-3", title: "第3集 · 运动会", desc: "一场接力赛，让两个一直较劲的人成了朋友。" },
      { id: "t7-4", title: "第4集 · 秘密", desc: "课桌里的一封信，被三个人读到了。" },
      { id: "t7-5", title: "第5集 · 毕业照", desc: "按下快门前，有人悄悄看向了另一个人。" },
      { id: "t7-6", title: "第6集 · 再见", desc: "散伙饭后，他们约定十年后再回到这间教室。" },
    ],
  },
  {
    id: "t8",
    title: "江湖行医录",
    subtitle: "一柄银针，走遍半壁山河",
    type: "tv",
    genres: ["武侠", "古装"],
    region: "大陆",
    year: 2025,
    duration: "全38集",
    rating: 8.1,
    director: "裴长风",
    cast: ["顾清尘", "陆昀", "温以宁"],
    cover:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%2C%20traveling%20young%20physician%20with%20a%20medicine%20chest%20on%20a%20misty%20mountain%20road%2C%20flowing%20robe%20and%20sword%2C%20jade%20green%20and%20ink%20black%20palette%2C%20elegant%20heroic%20mood%2C%20high%20detail&width=400&height=600&seq=t8-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Serene%20ancient%20Chinese%20mountain%20pass%20in%20morning%20mist%2C%20bamboo%20grove%20and%20a%20narrow%20stone%20path%2C%20jade%20green%20and%20ink%20grey%20tones%2C%20heroic%20wuxia%20atmosphere%2C%20high%20detail%20art&width=1600&height=800&seq=t8-banner-91aa&orientation=landscape",
    summary:
      "药王谷出身的年轻医者下山行医，一路救治百姓，也卷入江湖门派与朝廷之间的纷争。他逐渐明白，医者能救的是身，而人心之疾更难医。",
    updatedAt: "2026-10-07",
    hot: 7660,
    episodes: [
      { id: "t8-1", title: "第1集 · 下山", desc: "师父交给他一只药箱，只留下一句「莫问前程」。" },
      { id: "t8-2", title: "第2集 · 义诊", desc: "小镇的义诊摊前，来了一个不肯说症状的病人。" },
      { id: "t8-3", title: "第3集 · 冰蚕", desc: "一味罕见的药引，引来了两拨武林中人。" },
      { id: "t8-4", title: "第4集 · 旧怨", desc: "药王谷的旧事被人重新提起，恩怨浮出水面。" },
      { id: "t8-5", title: "第5集 · 瘟疫", desc: "一场突然蔓延的怪病，考验着所有人的信任。" },
      { id: "t8-6", title: "第6集 · 银针", desc: "他第一次在生死关头，用出了师门禁术。" },
    ],
  },
  {
    id: "t9",
    title: "迷雾档案",
    subtitle: "有些真相，只适合被遗忘",
    type: "tv",
    genres: ["悬疑", "惊悚"],
    region: "日韩",
    year: 2024,
    duration: "全16集",
    rating: 9.1,
    director: "高濑凉介",
    cast: ["木村昴", "佐藤凛", "小林和"],
    cover:
      "https://readdy.ai/api/search-image?query=Eerie%20mystery%20thriller%20series%20poster%2C%20foggy%20forest%20road%20with%20a%20single%20headlight%20beam%2C%20cold%20desaturated%20blue%20with%20a%20faint%20warm%20glow%2C%20unsettling%20atmospheric%20mood%2C%20minimal%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=t9-cover-91aa&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Thick%20fog%20over%20a%20dark%20pine%20forest%20road%20at%20night%2C%20cold%20desaturated%20blue%20tones%20with%20a%20faint%20amber%20light%20in%20the%20distance%2C%20eerie%20mysterious%20atmosphere%2C%20high%20detail%20cinematic&width=1600&height=800&seq=t9-banner-91aa&orientation=landscape",
    summary:
      "一档调查类节目的制作团队接手了一桩二十年前的失踪案。随着拍摄深入，他们发现每一个受访者都在讲同一个故事，却都有不同的结局。",
    updatedAt: "2026-10-15",
    hot: 9740,
    episodes: [
      { id: "t9-1", title: "第1集 · 素材", desc: "节目组收到一箱来源不明的旧录像带。" },
      { id: "t9-2", title: "第2集 · 受访者", desc: "第一位受访者说出了与档案完全不同的时间。" },
      { id: "t9-3", title: "第3集 · 空白带", desc: "一段被覆盖的录像，成了全场唯一的突破口。" },
      { id: "t9-4", title: "第4集 · 旧照片", desc: "照片里的人群中，有一位本不该出现的人。" },
      { id: "t9-5", title: "第5集 · 尾随", desc: "深夜剪辑室的门，被人从外面轻轻敲响。" },
      { id: "t9-6", title: "第6集 · 收官", desc: "节目播出前夕，主创收到了一个匿名包裹。" },
    ],
  },
];